import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { budgetTagsAPI, orderDetailsAPI } from 'src/app/services/apiRoutes';
import sortHelper from 'src/app/helpers/sort';
import { Observable } from 'rxjs';

@Injectable()
export class BudgetService {
  constructor(public http: HttpClient) {}

  /* budgets */
  getBudgets(id: string, page: number, budgetId: string) {
    var idBudget = '';
    if(budgetId)
      idBudget = "/"+budgetId;
    page = page -1;
    const sort = sortHelper.constructSort([{ prop: 'createdAt', dir: 'desc' }]);
    const pagination = '&page=' + page + '&size=10';
    return this.http.get(orderDetailsAPI + '/' + id + '/budget' + idBudget + sort + pagination).toPromise();
  }

  getBudgetsByName(id: string, page: number, queryParam:string){
    page = page -1;
    const pagination = '&page=' + page + '&size=10';
    return this.http.get(orderDetailsAPI + '/' + id + '/budget?name=' + queryParam /*+ "&sort=createdAt,desc" */+ pagination  ).toPromise();
  }

  createBudget(id: string, data) {
    return this.http.post(orderDetailsAPI + '/' + id + '/budget', data).toPromise();
  }

  updateBudget(budgetId: string, data) {
    return this.http.put(orderDetailsAPI + '/budget/' + data.identifier, data).toPromise();
  }

  getBudgetProducts(orderId: string) {
    return this.http.get<any>(orderDetailsAPI + '/' + orderId + '/product/available').toPromise();
  }

  deleteBudget(orderId: string, budgetId: string) {
    return this.http.delete(orderDetailsAPI + '/budget/' + budgetId).toPromise();
  }

  
  deleteBudgetAndMigrateHours(budgetId: string, migrateId) {
    var migrate = '';
    if(migrateId) {
      migrate = '/migrateTo/' + migrateId;
    }
    return this.http.delete(orderDetailsAPI + '/budget/' + budgetId + migrate).toPromise();
  }


  createBudgetProduct(budgetId: string, data) {
    return this.http.post(orderDetailsAPI + '/budget/' + budgetId + '/product', data).toPromise();
  }

  updateBudgetProduct(data) {
    return this.http.put(orderDetailsAPI + '/budget/product/' + data.identifier, data).toPromise();
  }

  deleteBudgetProduct(productId: string) {
    return this.http.delete(orderDetailsAPI + '/budget/product/' + productId).toPromise();
  }

  getBudgetProductsQuantity(orderId: string, budgetId: string) {
    return this.http.get<any>(orderDetailsAPI + '/' + orderId + '/product/available/quantity/' + budgetId).toPromise();
  }

  updateBudgetProductQuantity(budgetId, data) {
    return this.http.put(orderDetailsAPI + '/budget/' + budgetId + '/product/bulk', data).toPromise();
  }

  getWorklogsGroupedByBudget(orderId, budgets) {
    return this.http.post<any>(orderDetailsAPI + '/' + orderId + '/budget/worklogs', budgets).toPromise();
  }

  getBudgetSummaryChart(orderId) {
    return this.http.get<any>(orderDetailsAPI + '/' + orderId + '/budget/summary-chart').toPromise();
  }

  getProductSummaryChart(orderId) {
    return this.http.get<any>(orderDetailsAPI + '/' + orderId + '/lov/product/summary-chart').toPromise();
  }


  getBudgetAvailableProducts(orderId) {
    return this.http.get<any>(orderDetailsAPI + '/' + orderId + '/budget/products/exist').toPromise();
  }

  getTags(query: string): Observable<Array<string>> {
    return this.http.get<Array<string>>(budgetTagsAPI + '?query=' + query);
  }

  /* budgets end */
}
